import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'CellFormat',
})
export class CellFormat implements PipeTransform {
  transform(value: string): any {
    return value.replace(
      /^(\d{2})\D*(\d{5})\D*(\d{2})\D*(\d{2})$/g,
      '$1 $2-$3-$4',
    );
  }
}
